import React, {PureComponent} from 'react';
import {Flex} from 'reflexbox';

import Message from '../components/Messsage.js';

import './Messages.css';

class Messages extends PureComponent {
 componentDidMount() {
    this.scrollToTop();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  scrollToTop() {
    this.messagesBeg.scrollIntoView({behavior: "smooth"})
  }

  scrollToBottom() {
    this.messagesEnd.scrollIntoView({behavior: "smooth"})
  }

  render() {
    let messages = this.props.messages.map((message, idx) => (
      <Message
        author={message.author}
        text={message.text}
        pending={message.pending}
        key={idx}
      />
    ));

    return (
      <div className="messages">
        <div style={ {float:"left", clear: "both"} }
          ref={(el) => { this.messagesBeg = el; }}>
        </div>
        <Flex
          align={'center'}
          justify={'flex-start'}
          wrap={false}
          flexColumn={true}
        >
          {messages}
          <div style={ {float:"left", clear: "both"} }
            ref={(el) => { this.messagesEnd = el; }}>
          </div>
        </Flex>
      </div>
    )
  }
};

export default Messages;



// WEBPACK FOOTER //
// ./src/components/Messsages.js